import moment from 'moment'
import * as R from 'ramda'
import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'

import ArticleItemComponent from '../../components/ArticleItem'
import { ArticleItemSkeleton } from '../../components/Skeleton'
import { MEDIA_CONDITIONS } from '../../constants'
import { getArticleById } from '../../redux/article/selectors'
import { hk01LinkHandler } from '../../utils/commonUtils'
import mq from '../../utils/mediaQuery'

const Link = styled.a`
  ${mq.mobile} {
    width: 100%;
  }
`

const ArticleItem = React.memo(({ articleId, listView, onClick }) => {
  const { publishUrl, title, description, mainImage, publishTime } =
    useSelector(getArticleById(articleId)) || {}

  const isAppview = useSelector(R.path(['appState', 'isAppview']))

  const handleArticleClick = e => {
    onClick && onClick()
    hk01LinkHandler(e)
  }

  return R.isNil(articleId) ? (
    <ArticleItemSkeleton />
  ) : (
    <Link target='_blank' href={publishUrl} onClick={handleArticleClick}>
      <ArticleItemComponent
        title={title}
        description={description}
        mainImage={R.prop('cdnUrl', mainImage)}
        publishTime={moment.unix(publishTime).format('YYYY.MM.DD')}
        imageSizes={`${MEDIA_CONDITIONS.DESKTOP} 283px,${MEDIA_CONDITIONS.TABLET} 276px ,160px`}
        isAppview={isAppview}
      />
    </Link>
  )
})

export default ArticleItem
